import { AUTH_CONSTS, VACANCY_CONSTS } from "../constants";

export const initialState = {
    vacancyList: [],
    vacancyById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case VACANCY_CONSTS.GET_VACANCIES:
            return {
                ...state,
                vacancyList: action.payload || [],
            };
        case VACANCY_CONSTS.GET_VACANCIES_BY_ID:
            return {
                ...state,
                vacancyById: action.payload
            };
        case VACANCY_CONSTS.CREATE_VACANCY:
            return {
                ...state,
                vacancyList: [action.payload].concat(state.vacancyList)
            };
        case VACANCY_CONSTS.DELETE_VACANCY_BY_ID:
            return {
                ...state,
                vacancyList: state.vacancyList.filter(item => item.id !== action.payload)
            };
        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
